import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/* HTTP requests for type Blob return the error as a blob.  In order to the error, this 
	interceptor converts the blob to json
*/
@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(err => {
                //if (err instanceof HttpErrorResponse && err.error instanceof Blob && err.error.type === "application/json") {
				if (err instanceof HttpErrorResponse && err.status === 400 && req.responseType === 'blob') {
                    // https://github.com/angular/angular/issues/19888
                    // When request of type Blob, the error is also in Blob instead of object of the json data
                    return new Promise<any>((resolve, reject) => {
                        let reader = new FileReader();
                        reader.onload = (e: Event) => {
                            try {
                                const errmsg = JSON.parse((<any>e.target).result);
                                reject(new HttpErrorResponse({
                                    error: errmsg,
                                    headers: err.headers,
                                    status: err.status,
                                    statusText: err.statusText,
                                    url: err.url
                                }));
                            } catch (e) {
                                reject(err);
                            }
                        };
                        reader.onerror = (e) => {
                            reject(err);
                        };
                        reader.readAsText(err.error);
                    });
                }
                if (err instanceof HttpErrorResponse && err.status === 400 && req.responseType === 'arraybuffer') {
                    let clonedError = { ...err };
                    if (err.error instanceof ArrayBuffer) {
                        const decodedString = String.fromCharCode.apply(null, new Uint8Array(err.error));
                        clonedError.error = JSON.parse(decodedString);
                    }
                    const newError = new HttpErrorResponse(clonedError);
                    return new Promise<any>((resolve, reject) => {
                        reject(newError);
                    });
                }
                return throwError(err);
            })
        );
    }

}
